export default "__VITE_ASSET__CLPsNZgl__"